// GET /api/leaderboard: Rangliste ueber alle freigeschalteten Nutzer der
// Instanz (Entscheidung 01.09.2026, siehe api/src/routes/leaderboard.ts).

import { useQuery } from "@tanstack/react-query";
import { api } from "./api.js";

export interface Rang {
  userId: string;
  displayName: string;
  punkte: number;
  kennzeichen: number;
}

export function useLeaderboard() {
  return useQuery({
    queryKey: ["leaderboard"],
    queryFn: async () => (await api<{ rangliste: Rang[] }>("/leaderboard")).rangliste,
  });
}
